import { Popover, PopoverProps } from 'antd';
import { IconProps, Trash2 } from 'react-feather';
import { useIntl } from 'react-intl';
import ActionIcon from '../ActionIcon';

interface Props extends PopoverProps {
  onClick?: () => void;
  iconProps?: IconProps;
  disabled?: boolean;
}

const DeleteIcon: React.FC<Props> = ({
  onClick,
  iconProps,
  disabled,
  ...props
}) => {
  const intl = useIntl();

  return (
    <Popover
      {...props}
      content={
        props.content ||
        intl.formatMessage({ id: 'commons.list.action.button.delete' })
      }
    >
      <ActionIcon disabled={disabled}>
        <Trash2
          style={disabled ? { cursor: 'not-allowed' } : {}}
          color={disabled ? 'darkgray' : 'red'}
          size={20}
          cursor={'pointer'}
          onClick={!disabled ? onClick : undefined}
          {...iconProps}
        />
      </ActionIcon>
    </Popover>
  );
};

export default DeleteIcon;
